import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';

import './Breadcrumb.scss';

const Breadcrumb = (props) => {
  const { urls, names } = props;

  return (
    <div className="breadcrumbs d-flex flex-row align-items-center" data-testid="breadcrumb">
      <ul>
        <li key="breadcrumb-home"><Link to="/home">Home</Link></li>
        {urls.map((url, i) => names[i] && (
          <li key={`breadcrumb-${names[i]}`}>
            { typeof url === 'function'
            ? (
              <a className='link' onClick={url}>
                <i className="fa fa-angle-right" aria-hidden="true" />
                {names[i]}
              </a>
            )
            : (
            <Link to={url}>
              <i className="fa fa-angle-right" aria-hidden="true" />
              {names[i]}
            </Link>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

Breadcrumb.propTypes = {
  urls: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.func])).isRequired,
  names: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default Breadcrumb;
